import { type DocumentTypes } from "../../document";

export type ScanBarCodeRequest = {
  barcode: string;
  serial_numbers?: Record<string, string>;
};

export enum CommissioningWalkStateEnum {
  AwaitingPicklist = "awaiting_picklist",
  AwaitingPlace = "awaiting_place",
  AwaitingArticle = "awaiting_article",
  AwaitingConfirmation = "awaiting_confirmation",

  Finished = "finished",
}

export type CommissioningArticle = {
  variant_id: string;
  sku: string;
  ean: string;
  title: string;
  amount: string;
  best_before_date: string;
};

export type CommissioningWalkStateResource = {
  state: CommissioningWalkStateEnum;
  picklist_id: null | string;
  picklist_number: null | string;
  place_title: null | string;
  remaining_places: number;
  articles: CommissioningArticle[];
};

export enum ScanStateEnum {
  Accepted = "accepted",
  AwaitingSerialNumber = "awaiting_serial_number",
  OrderCompleted = "order_completed",
  PicklistCompleted = "picklist_completed",
  OrderCaptured = "order_captured",
  OrderPacked = "order_packed",
}

export type SerialNumber = {
  id: string;
  name: string;
};

export type ScanResultResource = {
  order_delivery_service_id: string;
  scan_type: "article" | DocumentTypes;
  state: ScanStateEnum;
  basket_number: null | string;
  scanned_barcode: string;
  order_number: string;
  headline: string;
  details: null | string;
  quantity_scanned: string | null;
  quantity_required: string | null;
  quantity_packed: string | null;
  serial_numbers: SerialNumber[];
  document_scan_count: number | null;
  label_scan_count: number | null;
};
